/**
 * Resilient fetch wrapper with automatic retry + exponential backoff.
 * Handles transient network errors (ERR_ABORTED from Cloudflare bot challenge,
 * DNS hiccups, brief offline moments) that commonly cause "failed to fetch"
 * on the very first API call after page load.
 */
export async function fetchWithRetry(url, options = {}, opts = {}) {
  const { retries = 3, backoffMs = 400, retryOnStatus = [502, 503, 504] } = opts;

  let lastError;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const res = await fetch(url, options);
      // Retry on transient gateway errors
      if (retryOnStatus.includes(res.status) && attempt < retries) {
        lastError = new Error(`HTTP ${res.status}`);
      } else {
        return res;
      }
    } catch (err) {
      lastError = err;
      if (attempt === retries) break;
    }
    // Exponential backoff: 400ms, 800ms, 1600ms
    await new Promise(r => setTimeout(r, backoffMs * Math.pow(2, attempt)));
  }
  throw lastError || new Error('fetchWithRetry failed');
}
